<template>
	<div>
		<div class="d-none">
			<div ref="pdf_content">
				<table cellspacing="0" cellpadding="0"
					style="font-family:Arial; width:525.75pt; margin-right:auto; margin-left:auto; margin-bottom: 50px; border:0.75pt solid #ffffff; border-collapse:collapse;">
					<tbody>
						<tr>
							<td width="80%"
								style="border-right:1.5pt solid #2c246d; padding:0.75pt 8.25pt 0.75pt 0.38pt; vertical-align:middle;">
								<p style="margin-top:0pt; margin-bottom:0pt; text-align:right; font-size:10pt; line-height: 13pt;">
									<strong style="font-size:13.5pt;">FINTOS CAPITAL SDN. BHD.</strong>
									<span>&nbsp;198401014613 (127169-T)</span><br>
									<strong><em><span>(Formerly known as Invinity Credit Sdn. Bhd.)</span></em></strong><br>
									<span>Puchong Financial Corporate Centre, Lot No. 11F-2, 11th Floor,</span><br>
									<span>Tower 4 @ PFCC, Jalan Puteri 1/2, Bandar Puteri, 47160 Puchong, Selangor.</span><br>
									<strong><span style="color:#2dbe7a;">Tel (O)</span></strong>
									<span style="color:#2dbe7a;">&nbsp;</span>
									<span>03-8080 9777 (Press No.4) |&nbsp;</span>
									<strong><span style="color:#2dbe7a;">(M)</span></strong>
									<strong><span> </span></strong>
									<span>+6012-347 9128&nbsp;</span><br><span>General Email: enquiryfintoscapital@fintos.com.my</span>
								</p>
							</td>
							<td style="vertical-align:middle;">
								<p style="margin-top:0pt; margin-bottom:0pt; text-align:right; line-height:150%; font-size:10pt;"><img
										:src="base64Logo"
										width="192" height="75" alt=""></p>
							</td>
						</tr>
					</tbody>
				</table>
				<div id="doc_statement_export">
					<table class="summary_info" border=0 cellpadding=0 cellspacing=0 width="100%">
						<tr>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<th colspan="3" style="font-size: 11pt;">STATEMENT OF ACCOUNT AS AT {{ _gHlp.formatMomentDate(_gHlp.getCurrentDateTime(),'D/MM/YYYY') }}</th>
						</tr>
						<tr>
							<td style="width: 120px;"><strong>Customer Name</strong></td>
							<td style="width: 5px;"><strong>:</strong></td>
							<td style="width: 240px;">{{ _gHlp.getValue(activeCustomer, 'name', '-') }}</td>
							<td></td>
							<td style="width: 150px;"><strong>Approved Date</strong></td>
							<td style="width: 5px;"><strong>:</strong></td>
							<td>{{ _gHlp.formatMomentDate(_gHlp.getValue(activeCase,'loan_approved_date',null),'D MMM YYYY') }}</td>
						</tr>
						<tr>
							<td><strong>Our Ref</strong></td>
							<td><strong>:</strong></td>
							<td>{{ _gHlp.getValue(activeCase, 'case_no', '-') }}</td>
							<td></td>
							<td><strong>Disbursed Date</strong></td>
							<td><strong>:</strong></td>
							<td>{{ _gHlp.formatMomentDate(_gHlp.getValue(activeCase,'disb_full_date',null),'D MMM YYYY') }}</td>
						</tr>
						<tr>
							<td><strong>Loan Amount</strong></td>
							<td><strong>:</strong></td>
							<td>RM {{ _gHlp.formatToMoney(_gHlp.getValue(activeCase, 'loan_amount', '0')) }}</td>
							<td></td>
							<td><strong>Payment Due Date</strong></td>
							<td><strong>:</strong></td>
							<td>{{ _gHlp.formatMomentDate(_gHlp.getValue(activeCase,'repay_first_due_date',null),'D') + '/xx' }}</td>
						</tr>
						<tr>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td><strong>Actual Instl (p.m.)</strong></td>
							<td><strong>:</strong></td>
							<td>RM {{ _gHlp.formatToMoney(actual_installment) }}</td>
						</tr>
						<tr>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td><strong>Total Interest Amount</strong></td>
							<td><strong>:</strong></td>
							<td>RM {{ _gHlp.formatToMoney(total_interest) }}</td>
						</tr>
						<tr>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td><strong>Outstanding Amount</strong></td>
							<td><strong>:</strong></td>
							<td><strong>RM {{ _gHlp.formatToMoney(total_balance) }}</strong></td>
						</tr>
					</table>
					<br />
					<table id="statement_list" border=0 cellpadding=0 cellspacing=0 width="100%">
						<thead>
							<tr class="hed">
								<th style="width: 120px;" >DATE</th>
								<th style="width: 400px;">DESCRIPTION</th>
								<th style="width: 80px;">LATE DAY</th>
								<th style="width: 100px;">CREDIT</th>
								<th style="width: 100px;">DEBIT</th>
								<th style="width: 100px;">BALANCE</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(data, index) in tableData" :key="index" :class="index % 2 === 0 ? 'even' : 'odd'">
								<td>{{ _gHlp.formatMomentDate(_gHlp.getValue(data,'statement_date',data.due_date),'D-MMM-YYYY')  }}</td>
								<td>{{ data.category + "-" + data.description }}</td>
								<td>{{ data.late_day }}</td>
								<td>{{ !_gHlp.isEmpty(data.credit) ? _gHlp.formatToMoney(data.credit) : '' }}</td>
								<td>{{ !_gHlp.isEmpty(data.debit) ? _gHlp.formatToMoney(data.debit) : '' }}</td>
								<td><strong>{{ _gHlp.formatToMoney(data.balance) }}</strong></td>
							</tr>
						</tbody>
						<tfoot>
							<tr class="bg-info">
								<td></td>
								<td></td>
								<td><strong>TOTAL</strong></td>
								<td><strong>{{ _gHlp.formatToMoney(total_credit) }} </strong></td>
								<td><strong>{{ _gHlp.formatToMoney(total_debit) }} </strong></td>
								<td><strong>{{ _gHlp.formatToMoney(total_balance) }} </strong></td>
							</tr>
						</tfoot>
					</table>
					<h5 class="text-center m-4">-- END OF STATEMENT --</h5>
					<table class="summary_info" border=0 cellpadding=0 cellspacing=0 width="90%">
						<tr>
							<td style="width: 200px;">TOTAL INTEREST CHARGE</td>
							<td style="width: 5px;">:</td>
							<td style="width: 100px;">RM {{ _gHlp.formatToMoney(total_interest_charge) }}</td>
							<td></td>
							<td style="width: 200px;">TOTAL CHARGE</td>
							<td style="width: 5px;">:</td>
							<td style="width: 100px;">RM {{ _gHlp.formatToMoney(total_charge) }}</td>
						</tr>
						<tr>
							<td>LATE PYMT CHARGE (LPC)</td>
							<td>:</td>
							<td>RM {{ _gHlp.formatToMoney(total_late_charge) }}</td>
							<td></td>
							<td>TOTAL INTEREST RECEIVED</td>
							<td>:</td>
							<td>RM {{ _gHlp.formatToMoney(total_interest_received) }}</td>
						</tr>
						<tr>
							<td>REBATE LATE PYMT CHARGE</td>
							<td>:</td>
							<td>RM {{ _gHlp.formatToMoney(total_late_waived) }}</td>
							<td></td>
							<td style="background-color: yellow;"><strong>INTEREST OUTSTANDING</strong></td>
							<td style="background-color: yellow;"><strong>:</strong></td>
							<td style="background-color: yellow;"><strong>RM {{ _gHlp.formatToMoney(total_interest_amt_outstanding) }}</strong></td>
						</tr>
						<tr>
							<td>MANUAL CHARGE</td>
							<td>:</td>
							<td>RM {{ _gHlp.formatToMoney(total_manual_fee) }}</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>MANUAL REBATE</td>
							<td>:</td>
							<td>RM {{ _gHlp.formatToMoney(total_manual_rebate) }}</td>
							<td></td>
							<td><strong>PRINCIPAL AMT RECEIVED</strong></td>
							<td>:</td>
							<td>RM {{ _gHlp.formatToMoney(total_principal_amt_received) }}</td>
						</tr>
						<tr>
							<td>MANUAL ADJUSTMENT</td>
							<td>:</td>
							<td>RM {{ _gHlp.formatToMoney(total_manual_adjustment) }}</td>
							<td></td>
							<td><strong>PRINCIPAL BALANCE</strong></td>
							<td>:</td>
							<td>RM {{ _gHlp.formatToMoney(total_principal_balance) }}</td>
						</tr>
						<tr>
							<td>TOTAL PYMT RECEIVED</td>
							<td>:</td>
							<td>RM {{ _gHlp.formatToMoney(total_repayment) }}</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
					</table>
					<p id="terms_condition">
						<strong>Terms & Conditions:</strong>
						<ul style="list-style: lower-alpha;">
							<li>Whilst every care has been taken in the preparation of this statement, it is subject to correction and confers no legal rights.</li>
							<li>The entries and balance shown above will be considered correct unless we are notified of any discrepancies within fourteen (14) days
							from the date of statement.</li>
							<li>For mail in payment, please detach the payment slip together with your payment. Do not staple or pin the cheque</li>
						</ul>
					</p>

					<p id="comments"><strong>Comments:</strong></p>
					<table id="payment_option" border=1 cellpadding=0 cellspacing=0 width="100%">
						<tbody>
							<tr>
								<td colspan="3"><strong>Payment Options</strong></td>
							</tr>
							<tr>
								<td>Remit To</td>
								<td>:</td>
								<td>
									<strong>
										FINTOS CAPITAL SDN. BHD. 
										<br/>(Formerly known as Invinity Credit Sdn. Bhd.)
									</strong>
								</td>
							</tr>
							<tr>
								<td>Bank Account No.</td>
								<td>:</td>
								<td>
									<strong>MBB : 512307622833</strong><br/>
									Please email your payment slip and your name, account no. and mobile number to:<br/>
									Email: enquiryfintoscapital@fintos.com.my<br/>
									Whatsapp: +6012-347 9128<br/>
								</td>
							</tr>
						</tbody>
					</table>
					<h5 class="text-center m-4">-- This is computer generated document and no signature is required. --</h5>
				</div>
			</div>
		</div>
		<div class="preview">
			<modal :show.sync="is_visible" :hide-footer="true" bodyClasses="preview-modal">
				<div class="text-center">
					<iframe v-if="!_gHlp.isEmpty(pdfUrl)" :src="pdfUrl" class="iframe-preview w-100"></iframe>
				</div>
			</modal>
		</div>
	</div>
</template>

<style>
#doc_statement_export{
	width: 100%;
	page-break-inside: auto;
	font-size: 9pt;
}
#doc_statement_export table{
	border: none;
	border-collapse: collapse;
	margin: 0 auto;
}
#doc_statement_export table:not(.summary_info) tr{
	page-break-inside: avoid;
}

#doc_statement_export table td,
#doc_statement_export table th{
	padding: 1px 5px !important;
	font-size: 9pt;
}

#doc_statement_export table.summary_info{
	margin-bottom: 20px;
	page-break-inside: avoid;
}

#doc_statement_export table#statement_list th{
	padding: 2px;
	background: #26A69A;
	font-size: 9.0pt;
	font-weight:400;
}
#doc_statement_export table#statement_list td{
	font-size: 9pt;
	border: none;
	padding: 5px;
	word-wrap: break-word;
  overflow-wrap: break-word;
}

#doc_statement_export table#statement_list tr.odd td,
#doc_statement_export table#statement_list tr.odd th {
	background: #DDF2F0;
}

#doc_statement_export table#statement_list tr.even td,
#doc_statement_export table#statement_list tr.even th {
	background: #f7fcfb;
}	

#doc_statement_export p#terms_condition{
	page-break-inside: avoid;
	margin-top: 10px;
}	
#doc_statement_export p#comments {
	margin-bottom: 10px;
	height: 70px;
}

#doc_statement_export table#payment_option {
	page-break-inside: avoid;
	border: solid 0.35px #585858;
	margin-top: 30px;
}
</style>

<script>
import { cloneDeep } from 'lodash'
import ExcelJS from 'exceljs';
import { mapState, mapActions } from 'pinia';
import { useCustomerStore } from '@/stores/customerStore';
import { useLoanCaseStore } from '@/stores/loanCaseStore';

export default {
	data() {
		return {
			// Add your component data here
			pdfUrl: null,
			is_visible: false,
			tableData: [],
			base64Logo:''
		};
	},
	async created() {
		this.base64Logo = await _gFile.getContentUrl('https://fintos-public.s3.ap-southeast-1.amazonaws.com/fintos_capital.jpg')
		// Add your created lifecycle hook here
	},
	computed: {
		...mapState(useCustomerStore, ['activeCustomer', 'activeLoanEC']),
		...mapState(useLoanCaseStore, ['activeStatements','activeCase','activeRepayments']),
		actual_installment(){
		 const loan_amount = _gHlp.getValue(this.activeCase,'loan_amount',0)
		 const interest_rate = _gHlp.getValue(this.activeCase,'interest_rate',0)
		 const tenure_year = _gHlp.getValue(this.activeCase,'loan_tenure_year',0)
		 let month = tenure_year * 12;
		 let total = 0;
		 if(['STL','FEL'].includes(_gHlp.getValue(this.activeCase,'loan_type_code'))){
				total = ((parseFloat(loan_amount) * (parseFloat(interest_rate) / 100)) + parseFloat(loan_amount)) / parseInt(month);
		 }else{
			 total = (((parseFloat(loan_amount) * (parseFloat(interest_rate) / 100)) * tenure_year) + parseFloat(loan_amount)) / parseInt(month);
		 }
		 return total;
		},
		total_interest(){
			return this.activeRepayments.reduce((acc, item) => {
				const amount = parseFloat(item.interest_amt);
				if (isNaN(amount)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		total_interest_charge(){
			const redemption = this.tableData.find((x) => { return (x.category == _gConst.paymentCategory.REDEMPTION)})
			const redemption_date	= (redemption) ? redemption.due_date : null
			const isSortLoan = ['STL','FEL'].includes(_gHlp.getValue(this.activeCase,'loan_type_code'))
			return this.activeRepayments.reduce((acc, item) => {
				const amount = parseFloat(item.interest_amt);
				const paid_status = _gHlp.getValue(item, 'paid_status', '-')
				if(isSortLoan){
					return acc + amount;
				}
				if (isNaN(amount) || _gHlp.isEmpty(item.due_date) || !_gHlp.checkIsDateExpired(item.due_date) || ((redemption_date) && _gHlp.compareDate(item.due_date,redemption_date, '>'))  || (paid_status.toLowerCase() != 'paid')) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		total_late_charge(){
			let total = this.tableData.reduce((acc, item) => {
				const amount = parseFloat(item.credit);
				if (isNaN(amount) || (item.category != _gConst.paymentCategory.LATE_CHARGES)) {
					return acc;
				}
				return acc + amount;
			}, 0);
			return parseFloat(total.toFixed(2))
		},
		total_interest_received(){
			let total = this.tableData.reduce((acc, item) => {
				const amount = parseFloat(item.credit);
				if (isNaN(amount) || (item.category != _gConst.paymentCategory.INTEREST)) {
					return acc;
				}
				return acc + amount;
			}, 0);

			return parseFloat(total.toFixed(2))
		},
		total_interest_qty(){
			if(['STL','FEL'].includes(_gHlp.getValue(this.activeCase,'loan_type_code'))){
				return _gHlp.getValue(this.activeCase,'loan_tenure')
			}

			let total = this.tableData.reduce((acc, item) => {
				if (item.category != _gConst.paymentCategory.INTEREST) {
					return acc;
				}
				return acc + 1;
			}, 0);
			return parseInt(total)
		},
		total_repayment(){
			let total = this.tableData.reduce((acc, item) => {
				const amount = parseFloat(item.debit);
				if (isNaN(amount) || ![_gConst.paymentCategory.REPAYMENT,_gConst.paymentCategory.REDEMPTION,_gConst.paymentCategory.ADVANCE_PAYMENT].includes(item.category)) {
					return acc;
				}
				return acc + amount;
			}, 0);
			// return parseFloat(total).toFixed(2) - parseFloat(this.total_manual_fee) + parseFloat(this.total_manual_rebate);
			return parseFloat(total).toFixed(2);
		},
		total_manual_rebate(){
			return this.tableData.reduce((acc, item) => {
				const amount = parseFloat(item.debit);
				if (isNaN(amount) || (item.category != _gConst.paymentCategory.MANUAL_REBATE)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		total_manual_fee(){
			let total = this.tableData.reduce((acc, item) => {
				const amount = parseFloat(item.credit);
				if (isNaN(amount) || (item.category != _gConst.paymentCategory.MANUAL_FEE_CHARGE)) {
					return acc;
				}
				return acc + amount;
			}, 0);
			return parseFloat(total.toFixed(2))
		},
		total_manual_adjustment(){
			return this.tableData.reduce((acc, item) => {
				const amount = parseFloat(item.debit);
				if (isNaN(amount) || (item.category != _gConst.paymentCategory.MANUAL_ADJUSTMENT)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		total_late_waived(){
			return this.tableData.reduce((acc, item) => {
				const amount = parseFloat(item.debit);
				if (isNaN(amount) || (item.category != _gConst.paymentCategory.LATE_WAIVED)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		total_adv_payment_balance(){
			let total = parseFloat(this.total_credit) - parseFloat(this.total_debit);
			return total >= 0 ? 0 : (total * -1);
		},
		total_credit() {
			let total = this.tableData.reduce((acc, item) => {
				const amount = parseFloat(item.credit);
				if (isNaN(amount)) {
					return acc;
				}
				return acc + amount;
			}, 0);

			return parseFloat(total.toFixed(2))
		},
		total_debit() {
			let total = this.tableData.reduce((acc, item) => {
				const amount = parseFloat(item.debit);
				if (isNaN(amount)) {
					return acc;
				}
				return acc + amount;
			}, 0);
			return parseFloat(total.toFixed(2))
		},
		total_balance() {
			return parseFloat(this.total_credit) - parseFloat(this.total_debit);
		},
		total_charge(){
			return parseFloat(this.total_interest_charge) + (parseFloat(this.total_late_charge) - parseFloat(this.total_late_waived)) + parseFloat(this.total_manual_fee);
		},
		total_interest_amt_outstanding(){
			let total = parseFloat(this.total_charge) - parseFloat(this.total_interest_received);
			return (total.toFixed(2) == 0.00) ? 0 : total;
		},
		total_principal_amt_received(){
			return (this.total_interest_qty * parseFloat(this.actual_installment)) - parseFloat(this.total_interest_received);
		},
		total_principal_balance(){
			const d = parseFloat(_gHlp.getValue(this.activeCase, 'disb_done_amt', 0))
			const i = parseFloat(this.total_interest_received)
			return (d+i) - parseFloat(this.total_manual_rebate) -  parseFloat(this.total_repayment);
		},
	},
	watch: {
		'pdfUrl': {
			handler(newValue, oldValue) {
				if (newValue) {
					console.log(newValue);
				}
			},
			immediate: true
		},
	},
	methods: {
		async show(data = []) {
			this.tableData = cloneDeep(data);
			await this.initPDF();
		},
		async initPDF() {
			// Capture the rendered HTML of the component (inside the `content` div)
			const content = this.$refs.pdf_content;
			this.pdfUrl = await _gFile.htmlToPdfUrl(content, 'Account_Statement_'+_gHlp.getValue(this.activeCase, 'case_id', '')+'_'+_gHlp.getCurrentDateTime(false)+'.pdf')
			this.is_visible = true;

		},
		exportToExcel(data = []){
			this.tableData = cloneDeep(data);

			const workbook = new ExcelJS.Workbook();
			const worksheet = workbook.addWorksheet('Account Statement', {views: [{showGridLines: false}]});
			const defaultFont = { name: 'Calibri', size: 12 };
			const defaultFontBold = { name: 'Calibri', size: 12, bold: true };
			const blankRow = {col_a: '',col_b: '',col_c: '',col_d: '',col_e: '',col_f: '',col_g: '',col_h: '',col_i: '',col_j: ''}

			//SETUP
			worksheet.columns = [{ key: 'col_a', width: 15.67 },{ key: 'col_b', width: 1.5 },{ key: 'col_c', width: 28.17 },{ key: 'col_d', width: 1.5 },{ key: 'col_e', width: 33.33 },{ key: 'col_f', width: 9 },{ key: 'col_g', width: 15.67 },{ key: 'col_h', width: 1.5 },{ key: 'col_i', width: 15.67 },{ key: 'col_j', width: 15.67 }];

			//HEADER
			worksheet.getCell('F1').value = {richText: [{ text: 'FINTOS CAPITAL SDN. BHD. ', font: { name: 'Calibri', size: 19, bold: true } },{ text: '198401014613 (127169-T)' , font: { name: 'Calibri', size: 12 }}]};
			worksheet.getCell('F1').alignment = { vertical: 'top', horizontal: 'right' };
			worksheet.getCell('F2').value = '(Formerly known as Invinity Credit Sdn. Bhd.)';
			worksheet.getCell('F2').font = { name: 'Calibri', size: 12, bold: true, italic: true };
			worksheet.getCell('F2').alignment = { vertical: 'top', horizontal: 'right' };
			worksheet.getCell('F3').value = 'Puchong Financial Corporate Centre, Lot No. 11F-2, 11th Floor,';
			worksheet.getCell('F3').font = defaultFont;
			worksheet.getCell('F3').alignment = { vertical: 'top', horizontal: 'right' };
			worksheet.getCell('F4').value = 'Tower 4 @ PFCC, Jalan Puteri 1/2, Bandar Puteri, 47160 Puchong, Selangor.';
			worksheet.getCell('F4').font = defaultFont;;
			worksheet.getCell('F4').alignment = { vertical: 'top', horizontal: 'right' };
			worksheet.getCell('F5').value = {richText: [
				{ text: 'Tel: ' , font: { name: 'Calibri', size: 12 }},
				{ text: '(O)' , font: { name: 'Calibri', size: 12, bold: true, color: { argb: '80D09C' }}},
				{ text: ' 03-8080 9777 (Press No.4) | ' , font: { name: 'Calibri', size: 12 }},
				{ text: '(M)' , font: { name: 'Calibri', size: 12, bold: true, color: { argb: '80D09C' }}},
				{ text: ' +6012-347 9128' , font: { name: 'Calibri', size: 12 }}
			]};
			worksheet.getCell('F5').alignment = { vertical: 'top', horizontal: 'right' };
			worksheet.getCell('F6').value = 'General Email: enquiryfintoscapital@fintos.com.my';
			worksheet.getCell('F6').font = defaultFont;
			worksheet.getCell('F6').alignment = { vertical: 'top', horizontal: 'right' };
			// Add header logo
			const imageId = workbook.addImage({
				base64: this.base64Logo,
				extension: 'jpg',
			});
			worksheet.addImage(imageId, 'G1:I6');

			//CONTENT
			//INFORMATIONS
			worksheet.getCell('F8').value = 'STATEMENT OF ACCOUNT AS AT '+_gHlp.formatMomentDate(_gHlp.getCurrentDateTime(),'D/MM/YYYY'); 
			worksheet.getCell('F8').font = { bold: true, size: 15 };
			worksheet.mergeCells('F8:J8');

			let profileSummary = [
				{ label: 'Customer Name', value: _gHlp.getValue(this.activeCase,'name','') },
				{ label: 'Our Ref', value:  _gHlp.getValue(this.activeCase,'case_no','') },
				{ label: 'Loan Amount', value: 'RM '+_gHlp.formatToMoney(_gHlp.getValue(this.activeCase,'loan_amount',0)) }
			];
			for (let i = 0; i < profileSummary.length; i++) {
				const el = profileSummary[i];
				let rw_no = 10 + i;
				worksheet.getCell('A'+rw_no).value = el.label; 
				worksheet.getCell('A'+rw_no).font = defaultFontBold;
				worksheet.getCell('B'+rw_no).value = ':'; 
				worksheet.getCell('C'+rw_no).value = el.value; 
				worksheet.getCell('C'+rw_no).font = defaultFont;
				worksheet.getCell('C'+rw_no).alignment = { vertical: 'bottom', horizontal: 'left' };
			}

			let statementSummary = [
				{ label: 'Approved Date', value: _gHlp.formatMomentDate(_gHlp.getValue(this.activeCase,'loan_approved_date',null),'D MMM YYYY') },
				{ label: 'Disbursed Date', value: _gHlp.formatMomentDate(_gHlp.getValue(this.activeCase,'disb_full_date',null),'D MMM YYYY') },
				{ label: 'Payment Due Date', value: _gHlp.formatMomentDate(_gHlp.getValue(this.activeCase,'repay_first_due_date',null),'D') + '/xx' },
				{ label: 'Actual Instl (p.m.)', value: 'RM '+_gHlp.formatToMoney(this.actual_installment) },
				{ label: 'Total Interest Amount', value: 'RM '+_gHlp.formatToMoney(this.total_interest) },
				{ label: 'Outstanding Amount', value: 'RM '+_gHlp.formatToMoney(this.total_balance) }
			];
			
			for (let i = 0; i < statementSummary.length; i++) {
				const el = statementSummary[i];
				let rw_no = 10 + i;
				worksheet.getCell('F'+rw_no).value = el.label; 
				worksheet.getCell('F'+rw_no).font = defaultFontBold;
				worksheet.mergeCells('F'+rw_no+':G'+rw_no);
				worksheet.getCell('H'+rw_no).value = ':'; 
				worksheet.getCell('I'+rw_no).value = el.value; 
				worksheet.getCell('I'+rw_no).font = defaultFont;
				worksheet.getCell('I'+rw_no).alignment = { vertical: 'bottom', horizontal: 'left' };
			}
			worksheet.addRow(blankRow);

			//STATEMENT TABLE
			//-STATEMENT TABLE HEADER
			const rowHeader = worksheet.addRow({
				col_a: 'Date',
				col_b:'',
				col_c: 'Description',
				col_d:'',
				col_e:'',
				col_f: 'Late Day',
				col_g: 'Credit',
				col_h:'',
				col_i: 'Debit',
				col_j: 'Balance'
			});
			rowHeader.eachCell((cell) => {
				cell.fill = {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: '80D09C' }
				};
				cell.font = defaultFont
			});

			//-STATEMENT TABLE BODY
			this.tableData.forEach((item, index) => {
				const row = worksheet.addRow({
					col_a: item.statement_date || item.due_date,
					col_b: '',
					col_c: `${item.category}\n${item.description}`,
					col_d: '',
					col_e: '',
					col_f: item.late_day || '',
					col_g: item.credit != 0 ? _gHlp.formatToMoney(item.credit) : '',
					col_h: '',
					col_i: item.debit != 0 ? _gHlp.formatToMoney(item.debit) : '',
					col_j: _gHlp.formatToMoney(item.balance)
				});
				// Merge cells for Description column
				const rowIndex = row.number;
				worksheet.mergeCells(`C${rowIndex}:E${rowIndex}`);
				// Set odd row color
				if (worksheet.rowCount % 2 === 0) {
					row.eachCell((cell) => {
						cell.fill = {
							type: 'pattern',
							pattern: 'solid',
							fgColor: { argb: 'E8F6EE' }
						};
						cell.font = defaultFont
					});
				}
				worksheet.getCell('J'+rowIndex).font = defaultFontBold;
			});

			//-STATEMENT TABLE FOOTER
			// console.log([this.total_credit,this.total_debit,this.total_balance, (this.total_credit - this.total_debit) ]);
			const rowTotal = worksheet.addRow({
				col_a: '',
				col_b: '',
				col_c: '',
				col_d: '',
				col_e: '',
				col_f: 'TOTAL',
				col_g: _gHlp.formatToMoney(this.total_credit),
				col_h: '',
				col_i: _gHlp.formatToMoney(this.total_debit),
				col_j: _gHlp.formatToMoney(this.total_balance)
			});
			rowTotal.eachCell((cell) => {
				cell.fill = {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: 'A1CDCE' }
				};
				cell.font = defaultFontBold
			});
			worksheet.addRow(blankRow);
			//END:STATEMENT TABLE

			//SUMMARY TABLE
			let nextRow = worksheet.getRow(worksheet.rowCount).number + 1; // Get the last row
			worksheet.getCell('A'+nextRow).value = '- END OF STATEMENT -';
			worksheet.getCell('A'+nextRow).font = defaultFontBold; 
			worksheet.getCell('A'+nextRow).alignment = { vertical: 'middle', horizontal: 'center' };
			worksheet.mergeCells('A'+nextRow+':J'+nextRow);
			worksheet.addRow(blankRow);
			let totalSummary = [
				{ label:'TOTAL INTEREST CHARGE', value: 'RM '+_gHlp.formatToMoney(this.total_interest_charge), label_2:'TOTAL CHARGE', value_2: 'RM '+_gHlp.formatToMoney(this.total_charge)},
				{ label:'LATE PYMT CHARGE (LPC)', value: 'RM '+_gHlp.formatToMoney(this.total_late_charge), label_2:'TOTAL INTEREST RECEIVED', value_2: 'RM '+_gHlp.formatToMoney(this.total_interest_received)},
				{ label:'REBATE LATE PYMT CHARGE', value: 'RM '+_gHlp.formatToMoney(this.total_late_waived), label_2:'INTEREST OUTSTANDING', value_2: 'RM '+_gHlp.formatToMoney(this.total_interest_amt_outstanding)},
				{ label:'MANUAL CHARGE', value: 'RM '+_gHlp.formatToMoney(this.total_manual_fee), label_2:'', value_2: ''},
				{ label:'MANUAL REBATE', value: 'RM '+_gHlp.formatToMoney(this.total_manual_rebate), label_2:'PRINCIPAL AMT RECEIVED', value_2: 'RM '+_gHlp.formatToMoney(this.total_principal_amt_received)},
				{ label:'MANUAL ADJUSTMENT ', value: 'RM '+_gHlp.formatToMoney(this.total_manual_adjustment), label_2:'PRINCIPAL BALANCE', value_2: 'RM '+_gHlp.formatToMoney(this.total_principal_balance)},
				{ label:'TOTAL PYMT RECEIVED', value: 'RM '+_gHlp.formatToMoney(this.total_repayment)},
			];
			totalSummary.forEach((item, index) => {
				const row = worksheet.addRow({
					col_a:'',
					col_b:'',
					col_c:item.label,
					col_d:':',
					col_e:item.value,
					col_f:item.label_2,
					col_g:'',
					col_h:':',
					col_i:item.value_2,
					col_j:'',
				});
				const rowIndex = row.number;
				if(item.label_2 == 'INTEREST OUTSTANDING'){
					worksheet.getCell(`F${rowIndex}:G${rowIndex}`).font = { bold: true };
					worksheet.getCell(`F${rowIndex}:G${rowIndex}`).fill = {
							type: 'pattern',
							pattern: 'solid',
							fgColor: { argb: 'FFFF54' }
						};
					worksheet.getCell(`I${rowIndex}`).font = { bold: true };
					worksheet.getCell(`I${rowIndex}`).fill = {
							type: 'pattern',
							pattern: 'solid',
							fgColor: { argb: 'FFFF54' }
						};
				}
				if(item.label_2 == 'PRINCIPAL AMT RECEIVED' || item.label_2 == 'PRINCIPAL BALANCE'){
					worksheet.getCell(`F${rowIndex}`).font = { bold: true };
					worksheet.getCell(`F${rowIndex}`).alignment = { vertical: 'bottom', horizontal: 'right' };
				}
				worksheet.getCell(`E${rowIndex}`).alignment = { vertical: 'bottom', horizontal: 'left' };
				worksheet.getCell(`I${rowIndex}`).alignment = { vertical: 'bottom', horizontal: 'left' };
				worksheet.mergeCells(`F${rowIndex}:G${rowIndex}`);
			})	

			//TERM & CONDITION
			nextRow = worksheet.getRow(worksheet.rowCount).number + 5; // Get the last row
			worksheet.getCell(`A${nextRow}`).value = 'Term & Conditions:';
			worksheet.getCell(`A${nextRow}`).font = { bold: true };
			let terms = [
			 { label: '    a. Whilst every care has been taken in the preparation of this statement, it is subject to correction and confers no legal rights.'},
			 { label: '    b. All item and balance shown will be considered correct unless the Bank is notified of any discrepancy within 14 days.'},
			 { label: '    c. For mail in payment, please detach the payment slip together with your payment. Do not staple or pin the cheque.'},
			];		
			terms.forEach((item, index) => {
				const row = worksheet.addRow({
					col_a:item.label
				});
				const rowIndex = row.number;
			})
			worksheet.addRow(blankRow);

			// REMIT REDEMPTION
			let remits = [
				{ value: { richText:[{ text:'Please remit the Redemption Sum to our Company\'s account with the following details: -' ,font:{bold:true}}]}},
				{ value: ''},
				{ value: { richText:[{ text:'Beneficiary: FINTOS CAPITAL SDN. BHD. ' ,font:{ bold:true }},{ text:'(Formerly known as Invinity Credit Sdn. Bhd.)' ,font:{bold:true, italic:true}}]}},
				{ value: 'Bank          : MAYBANK BERHAD'},
				{ value: 'A/C No.     : 512307622833'},
				{ value: 'Remarks    : Ref: [NAME]/[ACCOUNT NO.] (REPAYMENT & REDEMPTION)'},
				{ value: ''},
				{ value: { richText:[{ text:'*For e-payment transfer confirmation, please email to enquiryfintoscapital@fintos.com.my',font:{italic:true}}]}},
			];

			nextRow = worksheet.getRow(worksheet.rowCount).number + 1; // Get the last row
			for (let i = 0; i < remits.length; i++) {
				const el = remits[i];
				let rw_no = nextRow + i;
				worksheet.getCell(`C${rw_no}`).value = el.value;
			}

			//set border
			let startRow = nextRow ;
			let endRow = worksheet.getRow(worksheet.rowCount).number;
			let startCol = 'C';
			let endCol = 'I';
			for (let row = startRow; row <= endRow; row++) {
        for (let col = startCol.charCodeAt(0); col <= endCol.charCodeAt(0); col++) {
            const cell = worksheet.getCell(String.fromCharCode(col) + row);
            // Apply outer borders
            if (row === startRow && col == startCol.charCodeAt(0)) {
              cell.border = { top: { style: 'thin' }, left: { style: 'thin' } };
						}else if (row === startRow && col == endCol.charCodeAt(0)) {
							cell.border = { top: { style: 'thin' }, right: { style: 'thin' } };
						}else if (row === endRow && col == startCol.charCodeAt(0)) {
							cell.border = { bottom: { style: 'thin' }, left: { style: 'thin' } };
						}else if (row === endRow && col == endCol.charCodeAt(0)) {
							cell.border = { bottom: { style: 'thin' }, right: { style: 'thin' } };
						}else if (row === startRow) {
							cell.border = { top: { style: 'thin' } };
						}else if (row === endRow) {
							cell.border = { bottom: { style: 'thin' } };
						}else if (col === startCol.charCodeAt(0)) {
							cell.border = { left: { style: 'thin' } };
						}else if (col === endCol.charCodeAt(0)) {
							cell.border = { right: { style: 'thin' } };
						}
        }
    	}

			nextRow = worksheet.getRow(worksheet.rowCount).number + 3; // Get the last row
			worksheet.getCell('A'+nextRow).value = '- THIS IS A COMPUTER GENERATED STATEMENT -';
			worksheet.getCell('A'+nextRow).font = defaultFontBold; 
			worksheet.getCell('A'+nextRow).alignment = { vertical: 'middle', horizontal: 'center' };
			worksheet.mergeCells('A'+nextRow+':J'+nextRow);


			// download
			workbook.xlsx.writeBuffer().then(buffer => {
				const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				const link = document.createElement('a');
				link.href = URL.createObjectURL(blob);
				link.download = 'Account_Statement.xlsx';
				link.click();
			});

		}
	},
	// Add your computed properties here
};
</script>
